// Module
var code = "<div class=\"{{class}}\" id=\"{{id}}\"> <form class=\"data-form\" novalidate=\"\"> <div class=\"input-list\"></div> <div class=\"space\"></div> <div class=\"message\"></div> <div class=\"button-group\"> <button data-i18n=\"login_loginSignup\" type=\"submit\" class=\"btn btn-primary continue\"></button> </div> </form> </div>";
// Exports
module.exports = code;